export default __webpack_public_path__ + "static/media/transfer-bg.d6d67eed.jpg";